import { useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
  CircularProgress, Grid, Tab, Tabs, TablePagination
} from '@mui/material';
import { useFetchMisAprobaciones, useFetchResponderAprobacion } from '@/shared/actions/controlcambios/aprobacion-service.actions';
import { useAuthStore } from '@/store/auth';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ROUTER_PATHS } from '@/shared';
import { adaptAprobaciones } from '../../types';

export default function MisAprobacionesPage() {
  const USUARIO_ID = useAuthStore(s => s.user?.user_id);
  const navigate = useNavigate();
  const returnObservacionUrl = ROUTER_PATHS.control_cambios.cambioServicenav;

  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const tipo = tab === 0 ? 'PENDIENTES' : 'RESPONDIDAS';

  const { data: resp, isLoading } = useFetchMisAprobaciones(USUARIO_ID!, { tipo, page, size });
  // // const aprobaciones = resp?.data ?? [];
  // const aprobaciones = resp?.data as unknown as Aprobacion[];
  // // const total = resp?.totalElements ?? 0;
  // const total = (resp as any)?.totalElements;
  
  // const respuesta = resp as any  ;
  // const aprobaciones: Aprobacion[] = respuesta?.data ?? [];
  // const total:number = respuesta?.totalElements ?? 0;

  const {
  aprobaciones,
  totalElements:total,
  // page:pageAprobacion,
  // totalPages,
} = adaptAprobaciones(resp);



  const verCambio = (cambioId: string) =>
    navigate(`${returnObservacionUrl}/ver/${cambioId}`, { state: { from: ROUTER_PATHS.control_cambios.cambioServiceMisAprobacionesNav } });

  const respondMutation = useFetchResponderAprobacion();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [accion, setAccion] = useState<'APROBADO' | 'RECHAZADO'>('APROBADO');
  const [comentario, setComentario] = useState('');

  const cambiarTab = (_: any, v: number) => { setTab(v); setPage(0); };

  const abrirDialog = (id: string, ac: 'APROBADO' | 'RECHAZADO') => {
    setSelectedId(id); setAccion(ac); setComentario(''); setDialogOpen(true);
  };
  const confirmar = () => {
    if (!selectedId) return;
    respondMutation.mutate({ id: selectedId, data: { estadoAprobacion: accion, comentario } });
    setDialogOpen(false);
  };

  if (isLoading) return <CircularProgress sx={{ display: 'block', mx: 'auto', mt: 4 }} />;

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Mis Aprobaciones</Typography>

      <Tabs value={tab} onChange={cambiarTab} sx={{ mb: 2 }}>
        <Tab label="Pendientes" />
        <Tab label="Respondidas" />
      </Tabs>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              {/* <TableCell>Codigo</TableCell> */}
              <TableCell>Código control cambios</TableCell>
              <TableCell>Área de aprobador</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Comentario</TableCell>
              <TableCell>Fecha</TableCell>
              {tab === 0 && <TableCell align="center">Acción</TableCell>}
              <TableCell align="center">Ver</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {aprobaciones.map(a => (
              <TableRow key={a.aprobacionId}>
                {/* <TableCell>{a.codigo}</TableCell> */}
                <TableCell>{a.codigoCambio}</TableCell>
                <TableCell>{a.area?.nombre}</TableCell>
                <TableCell>
                  <Chip
                    label={a.estadoAprobacion}
                    color={a.estadoAprobacion === 'APROBADO' ? 'success' : a.estadoAprobacion === 'RECHAZADO' ? 'error' : 'warning'}
                    size="small"
                  />
                </TableCell>
                <TableCell>{a.comentario || '-'}</TableCell>
                <TableCell>{new Date(a.fechaCreacion).toLocaleDateString()}</TableCell>
                {tab === 0 && (
                  <TableCell align="center">
                    <Grid container spacing={1} justifyContent="center">
                      <Grid item>
                        <Button size="small" variant="contained" color="success"
                          onClick={() => abrirDialog(a.aprobacionId, 'APROBADO')}>Aprobar</Button>
                      </Grid>
                      <Grid item>
                        <Button size="small" variant="contained" color="error"
                          onClick={() => abrirDialog(a.aprobacionId, 'RECHAZADO')}>Rechazar</Button>
                      </Grid>
                    </Grid>
                  </TableCell>
                )}
                <TableCell align="center">
                  <Button size="small" variant="outlined" startIcon={<VisibilityIcon />}
                    onClick={() => verCambio(a.cambioId)}>Ver</Button>
                </TableCell>
              </TableRow>
            ))}
            {aprobaciones.length === 0 && (
              <TableRow><TableCell colSpan={7} align="center">Sin registros</TableCell></TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={(_, nueva) => setPage(nueva)}
          rowsPerPage={size}
          onRowsPerPageChange={(e) => { setSize(parseInt(e.target.value, 10)); setPage(0); }}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </TableContainer>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{accion === 'APROBADO' ? 'Aprobar' : 'Rechazar'} aprobación</DialogTitle>
        <DialogContent>
          <TextField autoFocus multiline rows={3} label="Comentario" fullWidth
            value={comentario} onChange={e => setComentario(e.target.value)} sx={{ mt: 1 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancelar</Button>
            <Button variant="contained" color={accion === 'APROBADO' ? 'success' : 'error'} onClick={confirmar} disabled={!comentario.trim()}>
            {accion === 'APROBADO' ? 'Aprobar' : 'Rechazar'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}